<template>
<div id="app">
  <app-header></app-header>
  <div class="content">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
  <app-footer class="footer"></app-footer>
</div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Oxygen&display=swap');
body {
  margin: 0;
  color: #292929;
  background-color: #f7f7f7;
}

html, body {
  height: 100%;
  font-family: 'Oxygen', sans-serif;
  font-size: 16px;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: 'Oxygen', sans-serif;
  font-size: 16px;
}

.content {
  flex: 1 0 auto;
  margin: 0 auto;
  padding: 10px 20px 10px 20px;
  margin-top: 20px;
}

.footer {
  flex-shrink: 0;
  min-height: 100px;
  padding: 20px 20px 5px 20px;
  background: #212121;
  color: #f7f7f7;
}

.left-space {
  margin-left: 15px;
}

.bold {
  font-weight: bold;
}

.right {
  float: right;
}

.left {
  float: left;
}

.rooster-red {
  color: #8a0707;
}

.page-header {
  padding-bottom: 5px;
  padding-right: 20px;
  width: fit-content;
  border-bottom: 4px solid #8a0707;
}

.rr-alert {
  margin: auto;
  text-align: center;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .content {
    width: 100%;
  }
  .announcements {
    margin-top: 30px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .content {
    width: 100%;
  }
  .announcements {
    margin-top: 30px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .content {
    width: 100%;
  }
  .announcements {
    margin-top: 0;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .content {
    width: 90%;
  }
  .announcements {
    margin-top: 0;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .content {
    width: 70%;
  }
  .announcements {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue